import { createTheme } from '@mui/material';

declare module '@mui/material/styles' {
  interface Palette {
    accent: {
      purple: string;
      purpleHover: string;
      purpleAlpha: string;
      dangerText: string;
      dangerSurface: string;
      warningText: string;
    };
  }
  interface PaletteOptions {
    accent?: {
      purple?: string;
      purpleHover?: string;
      purpleAlpha?: string;
      dangerText?: string;
      dangerSurface?: string;
      warningText?: string;
    };
  }
}

export const baseTheme = createTheme({
  typography: {
    fontFamily: 'Montserrat, Roboto, sans-serif',
  },
  palette: {
    background: { default: '#F3F3F3' },
    warning: { main: '#F3DA99', contrastText: '#2e2e2e', dark: '#cc9700' },
    success: { main: '#91e0c3', dark: '#4d9f8b', contrastText: '#2e2e2e' },
    error: { main: '#E99987', dark: '#ff7d6d', contrastText: '#2e2e2e' },
    primary: { main: '#2E2E2E', light: '#2E2E2E1A', dark: '#a80000', contrastText: '#fff' },
    secondary: { main: '#DD2424', light: '#DD2424A6', dark: '#a80000', contrastText: '#fff' },
    accent: {
      purple: '#b876f0',
      purpleHover: '#cc9ef7',
      purpleAlpha: 'rgba(168, 140, 234, 0.08)',
      // The status palettes are light tints (error.dark is lighter than error.main), so none of
      // them is readable as text on white. Use these for text; success.dark clears 3:1 for icons.
      dangerText: '#A01B1B',
      dangerSurface: 'rgba(221,36,36,0.08)',
      warningText: '#8a6600',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: '#2E2E2E',
          '&:hover': {
            backgroundColor: '#515151',
          },
        },
      },
      variants: [
        {
          props: { variant: 'contained', color: 'secondary' },
          style: {
            background: '#2E2E2E1A',
            color: '#2E2E2E',
            '&:hover': {
              backgroundColor: '#2E2E2E05',
            },
          },
        },
        {
          props: { variant: 'text' },
          style: {
            color: '#318ADC',
          },
        },
      ],
    },
    MuiSwitch: {
      styleOverrides: {
        colorPrimary: {
          '&.Mui-checked': {
            color: '#4b9b7e',
          },
          '&.Mui-checked.Mui-disabled': {
            color: '#91e0c4',
          },
        },
        track: {
          backgroundColor: '#dfdfdf',
          '.Mui-checked.Mui-checked + &': {
            backgroundColor: '#91e0c4',
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#DD2424',
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
          '&.Mui-disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
          },
          '&.Mui-disabled:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
          },
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
            '@media (hover: none)': {
              backgroundColor: '#FFF',
            },
          },
          '&.Mui-focused': {
            backgroundColor: '#fff',
          },
        },
      },
    },
  },
});
